import { useSearchParams } from "react-router-dom";
import { Spinner } from "../../../components/Spinner";
import { formatTimestamp } from "../../../lib/format";
import { useKuspitCalls, useKuspitOverview } from "../../../lib/queries";
import { EmptyRow, PageError, Pill } from "../shared";
import { KuspitFrame } from "./KuspitShared";

/** The connector call log: which internal operation was asked, how Kuspit answered and how long it took. */
export function AdminKuspitCallsPage() {
  const [params, setParams] = useSearchParams();
  const result = params.get("resultado") === "error" ? "error" : params.get("resultado") === "ok" ? "ok" : "";
  const endpoint = params.get("endpoint") ?? "";
  const calls = useKuspitCalls({ result, endpoint: endpoint || undefined });
  const overview = useKuspitOverview();
  const update = (key: string, value: string) => { const next = new URLSearchParams(params); if (value) next.set(key, value); else next.delete(key); setParams(next); };
  return (
    <KuspitFrame title="Llamadas al conector" subtitle="Bitácora de cada operación que el API pidió al conector Kuspit.">
      <div className="discover-toolbar">
        <div className="chip-row" role="tablist" aria-label="Filtrar por resultado">
          {[{ value: "", label: "Todas" }, { value: "error", label: "Con error" }, { value: "ok", label: "Exitosas" }].map((item) => (
            <button key={item.value || "all"} type="button" role="tab" aria-selected={result === item.value} className={`chip${result === item.value ? " active" : ""}`} onClick={() => update("resultado", item.value)}>{item.label}</button>
          ))}
        </div>
        <select className="standalone-input small" value={endpoint} onChange={(e) => update("endpoint", e.target.value)} aria-label="Filtrar por endpoint">
          <option value="">Todos los endpoints</option>
          {(overview.data?.calls24h.byEndpoint ?? []).map((row) => <option key={row.endpoint} value={row.endpoint}>{row.endpoint.replace("/internal/v1/", "")}</option>)}
        </select>
        <span className="toolbar-count">{calls.data?.length ?? 0} llamadas</span>
      </div>
      <p className="page-note">Solo se guarda el resultado, la latencia y una huella del cuerpo: nunca el token ni los datos del cliente. La correlación coincide con la del request del cliente y con la bitácora del API.</p>
      {calls.isLoading && <div className="page-state"><Spinner label="Cargando llamadas" /></div>}
      {calls.isError && <PageError title="No pudimos cargar las llamadas" retry={() => void calls.refetch()} />}
      {calls.data && (
        <div className="table-wrap">
          <table className="admin-table">
            <thead><tr><th>Cuándo</th><th>Endpoint interno</th><th>Resultado</th><th>HTTP</th><th>Latencia</th><th>Correlación</th></tr></thead>
            <tbody>
              {calls.data.map((call) => (
                <tr key={call.id} className={call.resultCode !== "OK" ? "row-bad" : undefined}>
                  <td>{formatTimestamp(call.createdAt)}</td>
                  <td className="mono">{call.endpoint.replace("/internal/v1/", "")}</td>
                  <td><Pill tone={call.resultCode === "OK" ? "ok" : "bad"} label={call.resultCode ?? "—"} /></td>
                  <td>{call.httpStatus ?? "—"}</td>
                  <td>{call.latencyMs} ms</td>
                  <td className="mono small" translate="no">{call.correlationId}</td>
                </tr>
              ))}
              {calls.data.length === 0 && <EmptyRow colSpan={6}>Sin llamadas registradas{result || endpoint ? " con este filtro" : ""}.</EmptyRow>}
            </tbody>
          </table>
        </div>
      )}
    </KuspitFrame>
  );
}
